const config = {
  // Table Columns
  columns: [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
      defaultSortOrder: 'ascend'
    },
    {
      title: 'Type',
      dataIndex: 'route_type__name',
      sorter: true,
      defaultSortOrder: 'ascend',
      width: '130px',
      render: (text, record) => record.type
    },
    {
      title: 'Mode',
      dataIndex: 'travel_mode',
      sorter: true,
      defaultSortOrder: 'ascend',
      width: '100px',
      render: (text, record) => record.travel_mode
    },
    {
      title: 'Depart',
      dataIndex: 'departure_location__name',
      sorter: true,
      defaultSortOrder: 'ascend',
      width: '200px',
      render: (text, record) => `${record.departure_location.name} (${record.departure_location.code})`
    },
    {
      title: 'Arrival',
      dataIndex: 'arrival_location__name',
      sorter: true,
      defaultSortOrder: 'ascend',
      width: '200px',
      render: (text, record) => `${record.arrival_location.name} (${record.arrival_location.code})`
    }
  ],
  // Filtering
  sorter: {
    field: 'name',
    order: 'ascend'
  },
  filters: {},
  customFilters: {
    name: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['name'],
      searchValue: ''
    },
    route_type__name: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['route_type__name'],
      searchValue: ''
    },
    travel_mode: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['travel_mode'],
      searchValue: ''
    },
    departure_location__name: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['departure_location__name'],
      searchValue: ''
    },
    arrival_location__name: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['arrival_location__name'],
      searchValue: ''
    }
  },
  // General
  commands: {
    showDelete: false,
    showAdd: false
  },
  showHeader: false,
  showPagination: false,
  classes: 'bhp-approved-route-list bhp-container'
};

export default config;
